import React from 'react';
import { Link } from 'react-router-dom';
import regex from '../../constants/regex';
import labelConstants from '../../constants/label';
import Text from '../../components/Common/Text';
import PropTypes from 'prop-types';

const JoinAsOrganiser = ({ validation, successMessage, isUpdateFormData }) => {
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
            }}
        >
            {successMessage && isUpdateFormData && (
                <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
                    {successMessage}
                </div>
            )}

            <div className="grid gap-3">
                <Text
                    validation={validation}
                    name="name"
                    label={labelConstants.NAME}
                    isRequire={true}
                    regexCompare={regex.NAME}
                    isLabelDisplay="No"
                    placeholder={labelConstants.NAME}
                    className="bg-white border border-[#E7E7E7] text-[#CB2129] text-[12px] md:text-base font-semibold font-body rounded-[4px] placeholder:text-[#9C9C9C] placeholder:font-normal focus:ring-blue-500 focus:border-blue-500 block w-full p-2 md:p-4"
                />

                <Text
                    validation={validation}
                    name="mobile"
                    label={labelConstants.MOBILE}
                    isRequire={true}
                    regexCompare={regex.MOBILE}
                    maxLength={10}
                    isLabelDisplay="No"
                    placeholder={labelConstants.MOBILE}
                    className="bg-white border border-[#E7E7E7] text-[#CB2129] text-[12px] md:text-base font-semibold font-body rounded-[4px] placeholder:text-[#9C9C9C] placeholder:font-normal focus:ring-blue-500 focus:border-blue-500 block w-full p-2 md:p-4"
                />

                <Text
                    className="bg-white border border-[#E7E7E7] text-[#CB2129] text-[12px] md:text-base font-semibold font-body rounded-[4px] placeholder:text-[#9C9C9C] placeholder:font-normal focus:ring-blue-500 focus:border-blue-500 block w-full p-2 md:p-4"
                    validation={validation}
                    name="email"
                    label="Email"
                    isLabelDisplay='No'
                    placeholder={labelConstants.EMAIL}
                    isRequire={true}
                />

                <Text
                    validation={validation}
                    name="company_name"
                    label={labelConstants.COMPANY_NAME}
                    isRequire={true}
                    regexCompare={regex.NAME}
                    placeholder={labelConstants.COMPANY_NAME}
                    isLabelDisplay="No"
                    className="bg-white border border-[#E7E7E7] text-[#CB2129] text-[12px] md:text-base font-semibold font-body rounded-[4px] placeholder:text-[#9C9C9C] placeholder:font-normal focus:ring-blue-500 focus:border-blue-500 block w-full p-2 md:p-4"
                />

            </div>
            <div className="flex justify-center gap-3 mt-[40px]">
                <button
                    type="submit"
                    className="btn-liner-gradient  text-white text-[12px] md:text-base font-medium py-1 md:py-[10px] px-3 md:px-7 rounded-[4px] md:rounded-lg"
                >
                    Join as organiser
                </button>
            </div>
        </form>
    );
};

JoinAsOrganiser.propTypes = {
    validation: PropTypes.object.isRequired,
    successMessage: PropTypes.string,
    isUpdateFormData: PropTypes.bool,
};
JoinAsOrganiser.defaultProps = {
    successMessage: '',
    isUpdateFormData: false,
};
export default JoinAsOrganiser;
